import { FiArrowUpRight } from "react-icons/fi";
import { Link } from "react-router-dom";
import { ShootingStars } from "./ui/shooting-stars";
import { StarsBackground } from "./ui/stars-background";
import { IoExtensionPuzzle } from "react-icons/io5";
import { RiTranslate2 } from "react-icons/ri";
import { FaArrowRightLong } from "react-icons/fa6";
import { BackgroundBeams } from "../Components/ui/background-beams";
import pinExtension from "../media/pinExtension.png";
import changeLanguage from "../media/changeLanguage.jpeg";
import selectLanguage from "../media/selectLanguage.png";
import { HashLink as Hlink } from "react-router-hash-link";
import Confetti from "react-confetti";
import { useState, useEffect, useRef } from "react";
import EmojiCannon from "./emojiCannon";
import Rating from "./rating";

function Main() {
  const [showConfetti, setShowConfetti] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => setShowConfetti(false), 10000);
    return () => clearTimeout(timer);
  }, []);

  const scrollWithOffset = (el) => {
    const yOffset = -90;
    const y = el.getBoundingClientRect().top + window.scrollY + yOffset;
    window.scrollTo({ top: y, behavior: "smooth" });
  };

  const emojiRef = useRef(null);
  const [fireInfo, setFireInfo] = useState(null);

  const handleClick = () => {
    if (emojiRef.current) {
      const rect = emojiRef.current.getBoundingClientRect();
      const x = rect.left + rect.width / 2;
      const y = rect.top + rect.height / 2;
      setFireInfo({ emoji: "🎉", position: { x, y } });
    }
  };

  return (
    <section className="relative top-0 left-0 min-h-screen overflow-hidden px-4 pt-20 text-white">
      {/* {showConfetti && (
        <Confetti
          width={window.innerWidth}
          height="1000"
          colors={["#bdcf32", "#5c8500", "#fff"]}
        />
      )} */}
      {/* Welcome & Intro */}
      {/* Feedback Section */}
      <section
        id="thanks"
        className="relative z-10 mx-5 bg-neutral-900 bg-opacity-50  rounded-xl shadow-2xl p-2 text-center overflow-hidden mb-5"
      >
        <div className="relative z-10 text-center px-4 pt-10 pb-12 space-y-6 rounded-xl shadow-2xl">
          <h1 className="text-3xl md:text-4xl font-bold">
            <button
              ref={emojiRef}
              onClick={handleClick}
              className="transition-transform duration-300 hover:scale-105"
            >
              🎉
            </button>
            {fireInfo && (
              <EmojiCannon
                emoji={fireInfo.emoji}
                position={fireInfo.position}
              />
            )}{" "}
            Thank You for Installing{" "}
            <span className="bg-gradient-to-r from-[#bdcf32] to-[#5c8500] bg-clip-text text-transparent">
              ProdNx!
            </span>
          </h1>
          <p className="text-lg md:text-xl font-normal leading-relaxed mx-auto">
            You’re all set to boost your focus, block distractions, and take
            control of your productivity.
          </p>
          <p>
            <Rating />
          </p>
        </div>
      </section>

      {/* Main Content */}
      <div className="relative z-10 mx-auto max-w-6xl space-y-12 px-4 md:px-10 bg-black bg-opacity-50 rounded-xl py-10">
        {/* Heading */}
        <h2 className="text-2xl md:text-3xl font-bold text-center">
          <span className="bg-gradient-to-r from-[#bdcf32] to-[#5c8500] bg-clip-text text-transparent">
            Let’s get started{" "}
          </span>
          <span className="text-xl md:text-2xl font-normal">
            — it only takes a minute!
          </span>
        </h2>

        {/* Step 1 */}
        <section className="space-y-4">
          <h3 className="text-2xl font-semibold">
            📌 <span className="text-[#bdcf32] font-bold">P</span>in the
            Extension
          </h3>
          <p className="text-lg">
            Click the extension icon{" "}
            <IoExtensionPuzzle className="inline-block align-middle text-xl" />{" "}
            in your browser toolbar, then pin <strong>Prodnx</strong>.
          </p>
          <img
            src={pinExtension}
            alt="How to pin the extension"
            className="mx-auto mt-6 shadow-lg w-full md:w-[50vw] lg:w-[35vw] rounded-lg"
          />
        </section>

        {/* Step 2 */}
        <section className="space-y-4">
          <h3 className="text-2xl font-semibold">
            🖱️ <span className="text-[#bdcf32] font-bold">O</span>pen to Explore
          </h3>
          <p className="text-lg">
            Once pinned, click the icon to start using all features of{" "}
            <strong>Prodnx</strong>.
          </p>
        </section>
        {/* </div> */}

        {/* Step 3 */}
        <section>
          <h2 className="text-2xl font-semibold mb-3">
            <RiTranslate2 className="inline-block text-3xl font-bold text-[#bdcf32]" />{" "}
            <span className="font-bold text-[#bdcf32]">L</span>anguage{" "}
            <span className="font-bold text-[#bdcf32]">S</span>election
          </h2>
          <p className="text-lg">
            We try to detect your language automatically. If not, we’ll ask you
            to choose.
            <br />
            You can always change it later via{" "}
            <strong>
              ProdNx <FaArrowRightLong className="inline" /> Info{" "}
              <FaArrowRightLong className="inline" /> Settings{" "}
              <FaArrowRightLong className="inline" /> Select Language
            </strong>
            <br />
            Currently we are supporting 20+ languages.
            <br />
            In case you can not find your language and want us to include it,
            fill out the{" "}
            <Hlink
              to="/getstarted/#feedback"
              scroll={(el) => {
                const yOffset = -90;
                const y =
                  el.getBoundingClientRect().top + window.scrollY + yOffset;
                window.scrollTo({ top: y, behavior: "smooth" });
              }}
              className="underline text-transparent bg-clip-text bg-gradient-to-r font-bold from-[#bdcf32] to-[#5c8500]"
            >
              Feedback Form
            </Hlink>
          </p>
          <img
            src={selectLanguage}
            alt="Select Language"
            className="mx-auto shadow-lg w-full hidden md:block mt-8"
          />
          <img
            src={changeLanguage}
            alt="Change Language"
            className="mx-auto shadow-lg w-full block md:hidden mt-8"
          />
        </section>

        {/* Tips */}
        <section>
          <h2 className="text-2xl font-semibold mb-3">
            💡 <span className="font-bold text-[#bdcf32]">T</span>ips &{" "}
            <span className="font-bold text-[#bdcf32]">T</span>ricks
          </h2>
          <ul className="text-lg list-decimal list-inside space-y-1">
            <li>Click on the extension button to pause tracking.</li>
            <li>You can also open New tab to stop tracking.</li>
            <li>
              Currently we only support website URLs to be tracked. If you want
              something else to be tracked, let us know your use case via
              feedback and if feasible, we will try to implement that.
            </li>
            <li>
              We support 20+ languages, choose your favourite one from settings.
            </li>
            <li>You can block website using the blocker tab.</li>
            <li>
              To generalize blocking, add a word (e.g. "mail") to block all URLs
              containing that name.
            </li>
            <li>
              There is a shortcut button in the blocker page to block that
              particular website.
            </li>
            <li>
              You can mark websites with tick or cross to personalize your
              productivity.
            </li>
            <li>
              For more features,{" "}
              <Hlink
                to="/#features"
                scroll={scrollWithOffset}
                className="underline text-transparent bg-clip-text bg-gradient-to-r font-bold from-[#bdcf32] to-[#5c8500]"
              >
                Click here
              </Hlink>
              .
            </li>
          </ul>
        </section>
      </div>

      {/* Feedback Section */}
      <section
        id="feedback"
        className="relative z-10 mt-16 mx-5 bg-neutral-900 bg-opacity-70 backdrop-blur-xl rounded-xl shadow-2xl p-8 text-center overflow-hidden"
      >
        <p className="text-white text-2xl md:text-3xl font-semibold mb-4">
          <strong>Issues or Feedback?</strong> Found a bug or have suggestions?
        </p>
        <p className="text-transparent text-xl md:text-2xl bg-clip-text bg-gradient-to-r font-bold from-[#bdcf32] to-[#5c8500] mb-6">
          FILL OUT THIS QUICK FORM AND HELP US IMPROVE!
        </p>
        <Link to="/feedback">
          <button className="relative inline-flex h-10 sm:h-12 overflow-hidden rounded-full p-[1px] hover:shadow-lg transition duration-300 cursor-pointer transition-transform duration-300 hover:scale-105">
            <span className="absolute inset-[-1000%] animate-[spin_2s_linear_infinite] bg-[conic-gradient(from_90deg_at_50%_50%,#bdcf32_0%,#5c8500_25%,#bdcf32_50%,#5c8500_75%,#bdcf32_100%)]" />
            <span className="inline-flex h-full w-full items-center justify-center rounded-full bg-slate-950 px-5 py-2 text-white text-base sm:text-lg font-medium backdrop-blur-3xl">
              Feedback Form
            </span>
          </button>
        </Link>
        <div className="absolute inset-0 z-0 w-full h-full overflow-hidden pointer-events-none">
          <BackgroundBeams />
        </div>
      </section>
    </section>
  );
}

export default Main;
